import { Container } from './styled';
import { useFlag } from '@/features/unleash';
import loadable from '@loadable/component';

const DeprecatedFilters = loadable(
  () => import('./components/DeprecatedFilters'),
  { resolveComponent: (module) => module.DeprecatedFilters }
);

const Filters = loadable(() => import('./components/Filters'), {
  resolveComponent: (module) => module.Filters,
});

interface Props {
  onChange: (id: string, rule: string) => void;
  onToggle: (toggledId: string, rule?: string) => void;
  toggledFilters: string[];
  rules: Record<string, string>;
}

export function MoreFiltersConfig({
  onToggle = () => null,
  onChange = () => null,
  toggledFilters = [],
  rules = {},
}: Props) {
  const { enabled } = useFlag({ name: 'screener-ui-update' });
  return (
    <Container>
      {enabled && typeof TEST_RUNNER === 'undefined' ? (
        <Filters
          onChange={onChange}
          onToggle={onToggle}
          toggledFilters={toggledFilters}
          rules={rules}
        />
      ) : (
        <DeprecatedFilters
          onChange={onChange}
          onToggle={onToggle}
          toggledFilters={toggledFilters}
          rules={rules}
        />
      )}
    </Container>
  );
}
